/* eslint-disable @typescript-eslint/no-explicit-any */
import { VerifiableCredential } from '../../common/types';
import { ClaimsDisplay, CredentialService } from './credentialService';

export default class StaticCredentialService implements CredentialService {
  async getDisplayClaimsForCredentials(credentials: VerifiableCredential[]): Promise<ClaimsDisplay> {
    for (let i = 0; i < credentials.length; i += 1) {
      const emailDisplay = credentials[i].credentialSubject?.contact as ClaimsDisplay;
      if (emailDisplay) {
        return emailDisplay;
      }
    }
    return {};
  }
}
